import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill", "fill-opacity"]

import { PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CreditCardIcon18',
  props: {
    fill: {
      type: String,
      default: 'black',
    },
    fillOpacity: {
      type: String as PropType<'1' | '0.54'>,
      default: '0.54',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 3.5H3C2.1675 3.5 1.5075 4.1675 1.5075 5L1.5 14C1.5 14.8325 2.1675 15.5 3 15.5H15C15.8325 15.5 16.5 14.8325 16.5 14V5C16.5 4.1675 15.8325 3.5 15 3.5ZM15 14H3V9.5H15V14ZM3 6.5H15V5H3V6.5Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_2)
  ]))
}
}

})